import { FolderOpenOutlined, FolderOutlined } from "@ant-design/icons";
import type { AntTreeNodeProps } from "antd/es/tree";

export default function CompetitionSwitcherIcon(props: AntTreeNodeProps) {
  const { expanded } = props;

  if (expanded) {
    return <FolderOpenOutlined />;
  }

  return <FolderOutlined />;
}
